import ApiService from "@/core/services/api.service";
import i18n from "@/core/plugins/vue-i18n";

const CONFIG_RESOURCE = "point_expiration/config";
const CONFIG_HISTORY_RESOURCE = "point_expiration/config/history";
const MEMBER_RESOURCE = "point_expiration/members";

function companyScope(companyId) {
  return companyId ? { company_id: companyId } : {};
}

function responseMessageOf(code) {
  const key = `RESPONSE_MESSAGE.${code}`;
  return i18n.te(key) ? i18n.t(key) : i18n.t("RESPONSE_MESSAGE.ERROR_OCCURRED");
}

function unwrapResponse({ data }) {
  if (data && data.status === "success") return data.data;
  throw new Error(responseMessageOf(data && data.error));
}

function failConnection() {
  throw new Error("เชื่อมต่อเซิร์ฟเวอร์ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
}

export function fetchPointExpireConfig(companyId) {
  ApiService.setHeader();
  return ApiService.getParams(CONFIG_RESOURCE, {
    params: companyScope(companyId)
  }).then(unwrapResponse, failConnection);
}

export function fetchPointExpireConfigHistory(companyId) {
  ApiService.setHeader();
  return ApiService.getParams(CONFIG_HISTORY_RESOURCE, {
    params: companyScope(companyId)
  }).then(unwrapResponse, failConnection);
}

function memberFilterParams({ type, dateFrom, dateTo } = {}) {
  return {
    ...(type ? { type } : {}),
    ...(dateFrom ? { date_from: dateFrom } : {}),
    ...(dateTo ? { date_to: dateTo } : {})
  };
}

export function fetchMemberPointExpiration(customerCampaignId, page, perPage, filters) {
  ApiService.setHeader();
  return ApiService.getParams(`${MEMBER_RESOURCE}/${customerCampaignId}`, {
    params: {
      page: String(page),
      perPage: String(perPage),
      ...memberFilterParams(filters)
    }
  }).then(unwrapResponse, failConnection);
}

export function savePointExpireConfig(companyId, payload) {
  ApiService.setHeader();
  return ApiService.put(CONFIG_RESOURCE, {
    ...payload,
    ...companyScope(companyId)
  }).then(unwrapResponse, failConnection);
}
